import React from 'react';

import CN from './FlareConfetti.module.scss';

const FlareConfetti = () => (
  <div data-bem="FlareConfetti" className={CN.component}>
    <div data-bem="FlareConfetti__container" className={CN.container}>
      <div className={CN.cnf00} />
      <div className={CN.cnf01} />
      <div className={CN.cnf02} />
      <div className={CN.cnf03} />
      <div className={CN.cnf04} />
      <div className={CN.cnf05} />
      <div className={CN.cnf06} />
      <div className={CN.cnf07} />
      <div className={CN.cnf08} />
      <div className={CN.cnf09} />
      <div className={CN.cnf10} />
      <div className={CN.cnf11}>
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>
      <div className={CN.cnf12}>
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>
    </div>

    <div data-bem="FlareConfetti__conf-duplicate" className={CN.confDuplicate}>
      <div className={CN.cnf00} />
      <div className={CN.cnf01} />
      <div className={CN.cnf02} />
      <div className={CN.cnf03} />
      <div className={CN.cnf04} />
      <div className={CN.cnf05} />
      <div className={CN.cnf06} />
      <div className={CN.cnf07} />
      <div className={CN.cnf08} />
      <div className={CN.cnf09} />
      <div className={CN.cnf10} />
    </div>

    <div data-bem="FlareConfetti__container-multiple" className={CN.containerMultiple}>
      <div className={CN.cnf11}>
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>
      <div className={CN.cnf12}>
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>
      <div className={CN.cnf13}>
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>
      <div className={CN.cnf01} />
      <div className={CN.cnf02} />
      <div className={CN.cnf03} />
      <div className={CN.cnf04} />
      <div className={CN.cnf05} />
      <div className={CN.cnf06} />
      <div className={CN.cnf07} />
      <div className={CN.cnf08} />
      <div className={CN.cnf09} />
      <div className={CN.cnf10} />
    </div>
  </div>
);

export default FlareConfetti;
